export class NotificationService {

    showInfo(message: string | string[]) {
        NotificationService.showMessageInternal("Info", message, "info");
    }

    showError(message: string | string []) {
        NotificationService.showMessageInternal("Error", message, "danger");
    }

    private static showMessageInternal(title: string, message: string | string[], type: string) {
        $.notify({
            title: title,
            message: Array.isArray(message) ? message.join("<br>") : message
        }, {
            type: type,
            delay: 5000,
            placement: {
                from: "top",
                align: "center"
            },
        });
    }
}